import {
  REAL_ESTATE_KIND__HOTEL,
  REAL_ESTATE_KIND__OFFICE_BUILDING,
  REAL_ESTATE_KIND__BUSINESS_BUILDING,
  REAL_ESTATE_KIND__OTHER,
  REAL_ESTATE_KIND__RESIDENCE,
  REAL_ESTATE_KIND__SPECIALTY_SHOPPING_CENTER,
  REAL_ESTATE_KIND__WAREHOUSE,
  USE_TYPE__OTHER,
  USE_TYPE__OWN_USE,
  USE_TYPE__THIRD_PARTY_RENTAL,
  USE_TYPE__BOTH,
  REAL_ESTATE__BRUTTO,
  REAL_ESTATE__NETTO,
  VEHICLE_KIND__CAR,
  VEHICLE_KIND__OTHER,
  VEHICLE_KIND__UTILITY_VEHICLE,
  MACHINE_CATEGORY__METAL,
  MACHINE_CATEGORY__PLASTIC,
  MACHINE_CATEGORY__WOOD,
  MACHINE_CATEGORY__TOOL,
  MACHINE_CATEGORY__PRINT,
  MACHINE_CATEGORY__CONSTRUCTION,
  MACHINE_CATEGORY__HEALTH,
  MACHINE_CATEGORY__ENERGY,
  MACHINE_CATEGORY__RENEWABLE_ENERGY,
  MACHINE_CATEGORY__FOOD,
  MACHINE_CATEGORY__LOGISTIC,
  MACHINE_CATEGORY__PACKAGING,
  MACHINE_CATEGORY__RECYCLING,
  MACHINE_CATEGORY__AGRICULTURE,
  MACHINE_CATEGORY__TELECOMMUNICATION,
  MACHINE_CATEGORY__OTHER,
  LOAN_KIND__AMORTISABLE_LOAN,
  LOAN_KIND__ANNUITY_LOAN,
  LOAN_KIND__LOAN_PAYABLE_AT_TERM,
  LOAN_FIXED_INTEREST_RATE__FIXED,
  LOAN_FIXED_INTEREST_RATE__VARIABLE,
  LEASING_AMORTISATION_KIND__FULL_AMORTISATION,
  LEASING_AMORTISATION_KIND__HIRE_PURCHASE,
  LEASING_AMORTISATION_KIND__PARTIAL_AMORTISATION,
  LEASING_AMORTISATION_KIND__UNDETERMINED,
  LEASING_TAKEOVER__NO,
  LEASING_TAKEOVER__UNDECIDED,
  LEASING_TAKEOVER__YES,
  REAL_ESTATE_KFW_STANDARD__40_PLUS,
  REAL_ESTATE_KFW_STANDARD__40,
  REAL_ESTATE_KFW_STANDARD__55
} from "./formFields";

export const useTypeOptions = [
  {
    label: "Eigennutzung",
    value: USE_TYPE__OWN_USE
  },
  {
    label: "Fremdvermietung",
    value: USE_TYPE__BOTH
  },
  {
    label: "Eigennutzung und Fremdvermietung",
    value: USE_TYPE__THIRD_PARTY_RENTAL
  },
  {
    label: "Andere Art der Nutzung",
    value: USE_TYPE__OTHER
  }
];

export const realEstateKindOptions = [
  {
    label: "Bürogebäude",
    value: REAL_ESTATE_KIND__OFFICE_BUILDING
  },
  {
    label: "Lager- / Produktionshalle",
    value: REAL_ESTATE_KIND__WAREHOUSE
  },
  {
    label: "Wohn- und Geschäftshaus",
    value: REAL_ESTATE_KIND__RESIDENCE
  },
  {
    label: "Geschäftshaus",
    value: REAL_ESTATE_KIND__BUSINESS_BUILDING
  },
  {
    label: "Fachmarktzentrum",
    value: REAL_ESTATE_KIND__SPECIALTY_SHOPPING_CENTER
  },
  {
    label: "Hotel",
    value: REAL_ESTATE_KIND__HOTEL
  },
  {
    label: "Sonstiges",
    value: REAL_ESTATE_KIND__OTHER
  }
];

export const nettoBruttoOptions = [
  {
    label: "Netto",
    value: REAL_ESTATE__NETTO,
    id: REAL_ESTATE__NETTO
  },
  {
    label: "Brutto",
    value: REAL_ESTATE__BRUTTO,
    id: REAL_ESTATE__BRUTTO
  }
];

export const vehicleKindOptions = [
  {
    label: "Pkw",
    value: VEHICLE_KIND__CAR,
    id: VEHICLE_KIND__CAR
  },
  {
    label: "Lkw",
    value: VEHICLE_KIND__UTILITY_VEHICLE,
    id: VEHICLE_KIND__UTILITY_VEHICLE
  },
  {
    label: "Sonstiges",
    value: VEHICLE_KIND__OTHER,
    id: VEHICLE_KIND__OTHER
  }
];

export const categoryOptions = [
  { label: "Metallbearbeitungsmaschine", value: MACHINE_CATEGORY__METAL },
  {
    label: "Holzbearbeitungsmaschine",
    value: MACHINE_CATEGORY__WOOD
  },
  {
    label: "Kunststoffverarbeitungsmaschine",
    value: MACHINE_CATEGORY__PLASTIC
  },
  {
    label: "Werkzeugmaschine",
    value: MACHINE_CATEGORY__TOOL
  },
  {
    label: "Druckmaschine",
    value: MACHINE_CATEGORY__PRINT
  },
  {
    label: "Baumaschine / -anlage",
    value: MACHINE_CATEGORY__CONSTRUCTION
  },
  {
    label: "Medizintechnik",
    value: MACHINE_CATEGORY__HEALTH
  },
  {
    label: "Energietechnik",
    value: MACHINE_CATEGORY__ENERGY
  },
  {
    label: "Energietechnik für erneuerbare Energien",
    value: MACHINE_CATEGORY__RENEWABLE_ENERGY
  },
  {
    label: "Lebensmittelherstellung",
    value: MACHINE_CATEGORY__FOOD
  },
  {
    label: "Lagertechnik u. Logistik",
    value: MACHINE_CATEGORY__LOGISTIC
  },
  {
    label: "Verpackungsmaschine",
    value: MACHINE_CATEGORY__PACKAGING
  },
  {
    label: "Entsorgungs- / Recyclingtechnik",
    value: MACHINE_CATEGORY__RECYCLING
  },
  {
    label: "Landmaschine",
    value: MACHINE_CATEGORY__AGRICULTURE
  },
  {
    label: "Telekommunikationsanlagen",
    value: MACHINE_CATEGORY__TELECOMMUNICATION
  },
  {
    label: "Sonstige Maschine / techn. Anlage",
    value: MACHINE_CATEGORY__OTHER
  }
];

export const loanOptions = [
  {
    label: "Tilgungsdarlehen",
    value: LOAN_KIND__AMORTISABLE_LOAN
  },
  {
    label: "Annuitätendarlehen",
    value: LOAN_KIND__ANNUITY_LOAN
  },
  {
    label: "endfälliges Darlehen",
    value: LOAN_KIND__LOAN_PAYABLE_AT_TERM
  }
];

export const loanFixedInterestRateOptions = [
  {
    label: "Fest",
    value: LOAN_FIXED_INTEREST_RATE__FIXED,
    id: LOAN_FIXED_INTEREST_RATE__FIXED
  },
  {
    label: "Variabel",
    value: LOAN_FIXED_INTEREST_RATE__VARIABLE,
    id: LOAN_FIXED_INTEREST_RATE__VARIABLE
  }
];

export const amortisationKindOptions = [
  {
    label: "Vollamortisation",
    value: LEASING_AMORTISATION_KIND__FULL_AMORTISATION
  },
  {
    label: "Teilamortisation",
    value: LEASING_AMORTISATION_KIND__PARTIAL_AMORTISATION
  },
  {
    label: "Mietkauf",
    value: LEASING_AMORTISATION_KIND__HIRE_PURCHASE
  },
  {
    label: "Ich möchte jetzt noch keine Entscheidung treffen",
    value: LEASING_AMORTISATION_KIND__UNDETERMINED
  }
];

export const leasingTakeoverOptions = [
  {
    label: "Ich möchte das Objekt übernehmen.",
    value: LEASING_TAKEOVER__YES
  },
  {
    label: "Ich möchte das Objekt zurückgeben.",
    value: LEASING_TAKEOVER__NO
  },
  {
    label: "Ich möchte jetzt noch keine Entscheidung treffen.",
    value: LEASING_TAKEOVER__UNDECIDED
  }
];

export const KFWStandardOptions = [
  {
    label: "KfW-Effizienzhaus 40 Plus",
    value: REAL_ESTATE_KFW_STANDARD__40_PLUS
  },
  {
    label: "KfW-Effizienzhaus 40",
    value: REAL_ESTATE_KFW_STANDARD__40
  },
  {
    label: "KfW-Effizienzhaus 55",
    value: REAL_ESTATE_KFW_STANDARD__55
  }
];
